document.addEventListener('DOMContentLoaded', function () {
  // Handle the quantity change
  document.addEventListener('click', function(e) {
    if (e.target.matches('.quantity_input_block #increase-qty')) {
      e.preventDefault();
      const productForm = e.target.closest('.custom-add-to-card-btn');
      let quantity = parseInt(productForm.querySelector('input[name="quantity"]').value);
      quantity += 1;
      productForm.querySelector('input[name="quantity"]').value = quantity;
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target.matches('.quantity_input_block #decrease-qty')) {
      e.preventDefault();
      const productForm = e.target.closest('.custom-add-to-card-btn');
      let quantity = parseInt(productForm.querySelector('input[name="quantity"]').value);
      if (quantity > 1) {
        quantity -= 1;
      }
      productForm.querySelector('input[name="quantity"]').value = quantity;
    }
  });

  document.addEventListener('submit', function(e) {
    if (e.target.matches('form[name="customAddToCart"]')) {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      const variantID = form.querySelector('input[name="id"]').value;
      const productQuantity = form.querySelector('input[name="quantity"]').value;

      customAddToCartProduct(variantID, Array.from(formData.entries()), form);
    }
  });
});

function customAddToCartProduct(variantID, formData, form) {
  const data = {properties: {}};
  const submitButton = form.querySelector('button');
  const loadingSpinner = form.querySelector('.loading__spinner');
  
  submitButton.disabled = true;
  loadingSpinner.classList.remove('hidden');

  formData.forEach(([name, value]) => {
    data[name] = value;
    if (name.startsWith('properties[')) {
      const propertyName = name.replace('properties[', '').replace(']', '');
      data.properties[propertyName] = value;
    }
  });

  let generatedFormData = {
    items: [data],
    sections: ['cart-drawer', 'cart-icon-bubble'],
    sections_url: window.location.pathname,
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(generatedFormData),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.renderContents(data);
        cartDrawer.open();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      submitButton.disabled = false;
      loadingSpinner.classList.add('hidden');
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
    });
}